import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAmbarAgreementSchemeRequest } from '../models/request/ambarAgreementScheme/AddAmbarAgreementSchemeRequest';
import { GetAmbarAgreementSchemeListPagingAndFilterRequest } from '../models/request/ambarAgreementScheme/GetAmbarAgreementSchemeListPagingAndFilterRequest';

export class AmbarAgreementSchemeService {
    static async getAmbarAgreementSchemeList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getAmbarAgreementSchemeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreementScheme/getAmbarAgreementSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAmbarAgreementSchemeList(inputObj: GetAmbarAgreementSchemeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAmbarAgreementSchemeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreementScheme/exportAmbarAgreementSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarAgreementSchemeListPagingAndFilter(inputObj: GetAmbarAgreementSchemeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAmbarAgreementSchemeListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreementScheme/GetAmbarAgreementSchemeListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAmbarAgreementScheme(inputObj: AddAmbarAgreementSchemeRequest) {
        try {
            console.log('SERVICE CALL - AddAmbarAgreementScheme', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreementScheme/AddAmbarAgreementScheme', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAmbarAgreementScheme(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAmbarAgreementScheme', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreementScheme/deleteAmbarAgreementScheme', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarAgreementSchemeById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAmbarAgreementSchemeById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AmbarAgreementScheme/getAmbarAgreementSchemeById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}